import { ReactElement } from 'react';
import { Spin } from 'common/components/antd/Spin/Spin';
import { SContainer } from './Loader.styles';

export const Loader = (): ReactElement => (
  <SContainer>
    <Spin />
  </SContainer>
);
